// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/authz_engines/obligations/obligations.proto
/* eslint-disable */
export const protobufPackage = "squareup.authz_engines.obligations";
export var Obligation;
(function (Obligation) {
    Obligation[Obligation["OBLIGATION_UNSPECIFIED"] = 0] = "OBLIGATION_UNSPECIFIED";
    Obligation[Obligation["ENROLL_SMS_2FA"] = 2] = "ENROLL_SMS_2FA";
    Obligation[Obligation["CHALLENGE_SMS_2FA"] = 3] = "CHALLENGE_SMS_2FA";
    Obligation[Obligation["CHALLENGE_EMAIL_2FA"] = 4] = "CHALLENGE_EMAIL_2FA";
    /**
     * CONTACT_CUSTOMER_SUPPORT - the below are cribbed from here: https://github.com/squareup/dashboard/pull/69862/files#diff-2b783105f4ec5edf71bfb108da93736fab6eae34940018811b14abb724b00944R45
     * we probably will not end up supporting exactly these after the POC.
     */
    Obligation[Obligation["CONTACT_CUSTOMER_SUPPORT"] = 5] = "CONTACT_CUSTOMER_SUPPORT";
    Obligation[Obligation["TWO_FACTOR_AUTH_ENROLLMENT"] = 6] = "TWO_FACTOR_AUTH_ENROLLMENT";
    Obligation[Obligation["TERMS_OF_SERVICE_ATTESTATION"] = 7] = "TERMS_OF_SERVICE_ATTESTATION";
    Obligation[Obligation["IDENTITY_VERIFICATION_USER_INPUT"] = 8] = "IDENTITY_VERIFICATION_USER_INPUT";
    Obligation[Obligation["IDENTITY_VERIFICATION_PENDING_APPROVAL"] = 9] = "IDENTITY_VERIFICATION_PENDING_APPROVAL";
    Obligation[Obligation["IDENTITY_VERIFICATION_SSP_DOCUMENT_UPLOAD"] = 10] = "IDENTITY_VERIFICATION_SSP_DOCUMENT_UPLOAD";
    Obligation[Obligation["IDENTITY_VERIFICATION_SSP_DOCUMENT_UPLOAD_APPROVAL"] = 11] = "IDENTITY_VERIFICATION_SSP_DOCUMENT_UPLOAD_APPROVAL";
    Obligation[Obligation["IDENTITY_VERIFICATION_VERIFF_DOCUMENT_UPLOAD"] = 12] = "IDENTITY_VERIFICATION_VERIFF_DOCUMENT_UPLOAD";
    Obligation[Obligation["REQUIRES_PAYMENTS_ACTIVATION"] = 13] = "REQUIRES_PAYMENTS_ACTIVATION";
    /** TWO_FACTOR_UPGRADE - Step Up Auth Framework obligations (2xx) */
    Obligation[Obligation["TWO_FACTOR_UPGRADE"] = 200] = "TWO_FACTOR_UPGRADE";
    Obligation[Obligation["TWO_FACTOR_ENROLL"] = 201] = "TWO_FACTOR_ENROLL";
    Obligation[Obligation["SCA_CHALLENGE"] = 202] = "SCA_CHALLENGE";
    Obligation[Obligation["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Obligation || (Obligation = {}));
